import React, { useState } from 'react'
import { AccountCircle } from '@mui/icons-material'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'
import Colors from 'utils/Colors'

import styles from './styles'

function MenuAvatar(props) {
  const { username, options } = props
  const classes = styles()

  const [anchorEl, setAnchorEl] = useState(null)

  const handleClose = () => {
    setAnchorEl(null)
  }

  function handleOpen(event) {
    setAnchorEl(event.currentTarget)
  }

  return (
    <div className={classes.root}>
      <span className={classes.name}>{username?.toLowerCase()}</span>
      <IconButton onClick={handleOpen}>
        <AccountCircle fontSize="large" htmlColor={Colors.white}/>
      </IconButton>
      <Menu
        id="options-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={classes.menu}
      >
        {addKeyToObjectsArray(options)?.map((option) => (
          <MenuItem
            key={option.key}
            onClick={option.action}
            disabled={option.disabled}
          >
            <span className={classes.option}>
              {option.icon}

              <span>
                {option.text}
              </span>
            </span>
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

export default MenuAvatar
